"use client";

import { cn } from "@gigpro/ui/tailwind/cn";
import type { FieldPath, FieldValues, UseControllerProps } from "react-hook-form";
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "..";
import { Switch as SwitchPrimitive, type SwitchProps } from "../../Switch";
import type { FormFieldProps } from "../types";

export const Switch = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  label,
  description,
  optional,
  className,
  name,
  control,
  shouldUnregister,
  ...switchProps
}: FormFieldProps<TFieldValues, TName> & Omit<SwitchProps, "className" | "checked" | "onCheckedChange" | "name">) => {
  const formFieldProps: UseControllerProps<TFieldValues, TName> = { name, control, shouldUnregister };
  return (
    <FormField
      {...formFieldProps}
      render={({ field, fieldState }) => (
        <FormItem className={cn("flex flex-col gap-y-1.5", className)}>
          <div className="flex items-center gap-2">
            <FormControl>
              <SwitchPrimitive
                name={name}
                {...switchProps}
                aria-invalid={fieldState.invalid}
                checked={!!field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <FormLabel optional={optional}>{label}</FormLabel>
          </div>
          <FormMessage />
          {!!description && <FormDescription>{description}</FormDescription>}
        </FormItem>
      )}
    />
  );
};

Switch.displayName = "Switch";
